import React from 'react';
import { Handshake, TrendingUp, Users, Calendar, Shield, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';

export const PartnershipSection = () => {
  const benefits = [
    {
      icon: Handshake,
      title: 'Vaste tarieven',
      description: 'Bij langdurige samenwerking profiteert u van vaste, scherpe tarieven zonder verrassingen.'
    },
    {
      icon: Calendar,
      title: 'Prioriteit in planning',
      description: 'Als vaste partner krijgt u voorrang bij het inplannen van opdrachten.'
    },
    {
      icon: Users,
      title: 'Vast contactpersoon',
      description: 'U krijgt een vast aanspreekpunt die uw bedrijf en wensen kent.'
    },
    {
      icon: TrendingUp,
      title: 'Schaalbaar',
      description: 'Wij groeien mee met uw bedrijf en passen onze diensten aan uw behoeften aan.'
    }
  ];

  return (
    <section className="py-14 lg:py-20 bg-black relative overflow-hidden">
      {/* Background effects */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-20 w-[400px] h-[400px] bg-yellow-400/10 rounded-full blur-3xl animate-float" />
        <div className="absolute bottom-20 right-20 w-[300px] h-[300px] bg-yellow-400/5 rounded-full blur-3xl animate-float" style={{ animationDelay: '2s' }} />
        <div className="absolute inset-0 opacity-[0.02]" style={{
          backgroundImage: `linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)`,
          backgroundSize: '60px 60px'
        }} />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left content */}
          <div>
            <span className="inline-flex items-center gap-2 bg-yellow-400/20 text-yellow-400 px-4 py-2 rounded-full text-sm font-semibold mb-6 border border-yellow-400/20">
              <Handshake className="w-4 h-4" />
              Partnerschap
            </span>
            <h2 className="text-4xl md:text-5xl font-black text-white mb-6 leading-tight">
              Open voor
              <span className="text-yellow-400"> langdurige samenwerking</span>
            </h2>
            <p className="text-xl text-neutral-300 mb-8 leading-relaxed">
              Bij Nexon Service geloven wij in het opbouwen van sterke, langdurige relaties met onze klanten. Of u nu een eenmalige opdracht heeft of zoekt naar een betrouwbare logistieke partner voor de lange termijn – wij staan voor u klaar.
            </p>
            <div className="space-y-4 mb-10">
              <div className="flex items-center gap-3 text-neutral-300">
                <div className="w-6 h-6 bg-yellow-400 rounded-full flex items-center justify-center">
                  <Shield className="w-3.5 h-3.5 text-white" />
                </div>
                <span>Raamovereenkomsten voor bedrijven</span>
              </div>
              <div className="flex items-center gap-3 text-neutral-300">
                <div className="w-6 h-6 bg-yellow-400 rounded-full flex items-center justify-center">
                  <Clock className="w-3.5 h-3.5 text-white" />
                </div>
                <span>Flexibele contractvormen mogelijk</span>
              </div>
              <div className="flex items-center gap-3 text-neutral-300">
                <div className="w-6 h-6 bg-yellow-400 rounded-full flex items-center justify-center">
                  <TrendingUp className="w-3.5 h-3.5 text-white" />
                </div>
                <span>Volume kortingen bij regelmatige opdrachten</span>
              </div>
            </div>
            <Link to="/contact">
              <Button size="lg" className="bg-yellow-400 hover:bg-yellow-400 text-black px-8 py-6 rounded-2xl shadow-xl shadow-yellow-400/20 hover:shadow-yellow-400/30 transition-all text-lg">
                Neem contact op voor partnership
              </Button>
            </Link>
          </div>

          {/* Right benefits grid */}
          <div className="grid grid-cols-2 gap-5">
            {benefits.map((benefit, idx) => (
              <div 
                key={idx} 
                className="group p-6 bg-white/5 hover:bg-white/10 rounded-2xl border border-white/10 hover:border-yellow-400/30 transition-all duration-300 backdrop-blur-sm"
              >
                <div className="w-12 h-12 bg-yellow-400 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform shadow-lg">
                  <benefit.icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-lg font-bold text-white mb-2">{benefit.title}</h3>
                <p className="text-neutral-400 text-sm leading-relaxed">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
